export default {
	data() {
		return {}
	},
	props: ['params'],
	methods: {
		reset_filters(){
			this.$store.dispatch('resetContacts');
		}
	},
	computed:{},
	watch: {},
	components: {}
}